import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CATEGORY_VIDEOS } from '@/config/mediaConfig';

const CATEGORIES = [
  {
    name: 'WORKSTATIONS',
    description: 'Transform your office with ergonomic modular desks',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop',
    video: CATEGORY_VIDEOS['Modular Office Workstation'],
    link: '/products?category=Modular Office Workstation',
    price: 'Starting from ₹5,320'
  },
  {
    name: 'STORAGE',
    description: 'Organize your workspace with smart storage',
    image: 'https://images.unsplash.com/photo-1595428774839-7e35900fb7f1?w=800&h=600&fit=crop',
    video: CATEGORY_VIDEOS['Storage Cabinets'],
    link: '/products?category=Storage Cabinets',
    price: 'Starting from ₹4,226'
  },
  {
    name: 'PRIVACY BOOTHS',
    description: 'Create focused spaces for calls and meetings',
    image: 'https://images.unsplash.com/photo-1636294155450-4aad425a970b?w=800&h=600&fit=crop',
    video: CATEGORY_VIDEOS['Privacy Booths'],
    link: '/products?category=Privacy Booths',
    price: 'Starting from ₹1,35,000'
  }
];

export function CategoriesGrid() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-[#c5a059] text-sm tracking-[0.3em] uppercase mb-4 font-medium">
            Our Collection
          </p>
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-4"
            
          >
            The Executive Suite
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Premium modular furniture designed for modern workspaces
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {CATEGORIES.map((cat, i) => (
            <Link 
              key={cat.name}
              to={cat.link}
              className={`group relative overflow-hidden ${i === 0 ? 'md:col-span-2 md:row-span-2' : ''}`}
              data-testid={`category-${cat.name.toLowerCase().replace(' ', '-')}`}
            >
              <div className={`relative ${i === 0 ? 'h-[500px]' : 'h-[240px]'}`}>
                {cat.video ? (
                  <video
                    src={cat.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                ) : (
                  <img 
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    width={600}
                    height={400}
                    loading="lazy"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/90 via-[#1a1a1a]/40 to-transparent" />
                
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="inline-block bg-[#c5a059] text-[#1a1a1a] px-4 py-2 mb-3 rounded">
                    <p className="text-sm font-bold tracking-wide">{cat.price}</p>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2" >
                    {cat.name}
                  </h3>
                  <p className="text-gray-300 text-sm mb-4">{cat.description}</p>
                  <span className="inline-flex items-center gap-2 text-[#c5a059] text-sm font-medium tracking-wider group-hover:gap-3 transition-all">
                    EXPLORE <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
